import { gql, useQuery } from '@apollo/client';
import { ClearingDepositInstrumentType } from '../../../../../../../../types/gql';
import { BankDetails } from './index.types';

const detailsFragment = gql`
  fragment AbroadBankDepositDetails on ClearingAbroadBankDepositDetails {
    bankName
    swift
    bankAddress
    intermediaryBankName
    intermediarySwift
    recipient
    accountOfReceiver
    recipientAddress
    purposeOfPayment
    correspondentAccount
  }
`;

const query = gql`
  query BankDetails {
    currentUser {
      id
    }
    clearing {
      depositInstruments(product: "UTCOM") {
        type
        currency
        details {
          ... on ClearingAbroadBankDepositDetails {
            ...AbroadBankDepositDetails
          }
        }
      }
    }
  }

  ${detailsFragment}
`;

export const useBankDetails = () => {
  const { data, loading, error } = useQuery<BankDetails>(query);

  const instrument = data?.clearing?.depositInstruments?.find(
    (instrument) =>
      instrument.type === ClearingDepositInstrumentType.OnlineBankTransfer &&
      instrument.currency === 'USD'
  );

  return {
    details: instrument?.details,
    currentUserId: data?.currentUser?.id,
    loading,
    error,
  };
};
